import React from 'react';
import { Empty, Table as TableComponent } from 'antd';
import { Container } from './styles';
const Table = ({
  columns,
  dataSource,
  onChange,
  pagination,
  emptyText,
  className,
  locale
}) => {
  return <Container data-testid="table">
      <TableComponent className={className} locale={locale ?? {
      emptyText: emptyText ?? <Empty description="Nothing here yet" image={Empty.PRESENTED_IMAGE_SIMPLE} />
    }} columns={columns} dataSource={dataSource} pagination={pagination} onChange={onChange} scroll={{
      x: 500
    }} />
    </Container>;
};
export default Table;